import React from 'react';
import { Link } from 'react-router-dom';

const ErrorPage = () => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#f8d7da',
          color: '#721c24',
          textAlign: 'center',
          padding: '20px',
        }}
      >
        <h1 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>
          [서버 상태 공지사항]
        </h1>
        <div style={{ marginBottom: '20px' }}>
          <p>서버 상태가 불안정해 복구 중에 있습니다.</p>
          <p>오류가 발생하면 문의 메일로 문의 부탁드립니다.</p>
          <p>불편을 드려 죄송합니다.</p>
        </div>
        <div>
          <button
            style={{
              backgroundColor: '#007bff',
              color: '#fff',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              textDecoration: 'none',
            }}
          >
            <Link
              to={'mailto:admin@gbit.kr'}
              style={{ color: '#fff', textDecoration: 'none' }}
            >
              문의 메일 보내기
            </Link>
          </button>
        </div>
      </div>
    </>
  );
};

export default ErrorPage;
